export default "__VITE_ASSET__f9r9MHEg__"